import { getDataFromApi } from '../helpers/ApiHelper';
import { DataSourceFilterModel } from '../models/Consumer/DataSourceFilterModel';

export class DataSourceFiltersService {
  public static getDataSourceFilters(): Promise<DataSourceFilterModel[]> {
    return getDataFromApi<DataSourceFilterModel[]>('/data-source-filters ');
  }
}
